import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-why-pursue-bachelor-of-computer-application',
  templateUrl: './why-pursue-bachelor-of-computer-application.component.html',
  styleUrls: ['./why-pursue-bachelor-of-computer-application.component.scss']
})
export class WhyPursueBachelorOfComputerApplicationComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
